import { registerQuery, useQuery } from '../../utils/DataFetchingClient';
import { noAuthApiClient } from '../http';
export const userProfilePath = 'hsn/user/profiles';
export const GET_USER_BY_ID = registerQuery({
  fieldName: 'userById',
  args: ['userId'],

  fetcher({
    userId
  }) {
    return noAuthApiClient.get(`${userProfilePath}/user-id/${userId}`);
  }

});
export const useConnectDotComUserById = userId => {
  const {
    data: connectDotComUser,
    error: connectDotComUserError,
    loading: connectDotComUserLoading
  } = useQuery(GET_USER_BY_ID, {
    variables: {
      userId: userId
    },
    skip: !userId
  });
  return {
    connectDotComUser,
    connectDotComUserError,
    connectDotComUserLoading
  };
};
export const useConnectDotComUser = userId => {
  return useConnectDotComUserById(userId);
};